import React from "react";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { ArrowDownward } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";

export const DownloadReportButton = ({
  downloadURL,
  loading,
}: {
  downloadURL: string;
  loading: boolean;
}) => {
  if (loading) {
    return (
      <OrangeTextButton
        onClick={() => {}}
        text={
          <span className="inline-flex items-center">
            <CircularProgress size={16} sx={{ color: "white" }} />
            &nbsp;Fetching Report...
          </span>
        }
        disabled={true}
      />
    );
  }

  return (
    <OrangeTextButton
      onClick={() => {}}
      text={
        <>
          <ArrowDownward />
          &nbsp;
          <a href={downloadURL} download>
            Download Report
          </a>
        </>
      }
      disabled={!downloadURL}
    />
  );
};
